// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface GithubConfigOut {}

export const GithubConfigOutSerializer = {
  _fromJsonObject(_object: any): GithubConfigOut {
    return {};
  },

  _toJsonObject(_self: GithubConfigOut): any {
    return {};
  },
};
